<template>
  <div id="pressure">
    <div class="title">实时压力值</div>
    <ul class="tab_1">
      <li>项目名称</li>
      <li>设备名称</li>
      <li>压力值</li>
    </ul>
    <div class="scroll" ref="scroll_1">
      <div>
        <ul class="tab_2" v-for="(data,index) in pressuredata" :key="data.water_device_code">
          <li class="box_1" :class="{ change_color: index % 2 === 1}">
            <ul class="box_2">
              <li>{{ data.dept_name }}</li>
              <li>{{ data.water_device_name }}</li>
              <li>{{ data.pma_value | pressNumFilter }}MPa</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="custom-vertical-scrollbar" ref="vertical_1">
        <div class="custom-vertical-indicator"></div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll' 
import ScrollBar from '@better-scroll/scroll-bar'
BScroll.use(ScrollBar)
//import axios from 'axios'
export default {
  data() {
    return {
      pressuredata: [],
    };
  },
  mounted() {
    //post传递的参数
    this.getpressdata();
    
    //定时重新获取数据
    setInterval(()=>{
      this.getpressdata();
    },60000)

  },
  methods: {
    getpressdata(){
      // 获取数据
      // alertcolor:data.pma_value<0.35&&$store.state.hours>=12&&$store.state.hours<=13 
      this.pressuredata = [];
//    var params = new URLSearchParams();
//    params.append("deptId", "892");
//    params.append("checkCode", "3F55CAEAEAA1261CEFB7369CB6987DDB");
//    axios.post("/api/data/getRealTimePmaValue", params)
//      .then((res) => {

          this.pressuredata=[
						{pma_value: "0.388", water_device_code: "970850470", dept_name: "智慧学院", water_device_name: "生活服务区总表"},
						{pma_value: "0.085", water_device_code: "970850453", dept_name: "智慧学院", water_device_name: "实验楼外分区"},
						{pma_value: "0.089", water_device_code: "970850468", dept_name: "智慧学院", water_device_name: "教学行政区总表"},
						{pma_value: "0.007", water_device_code: "970850465", dept_name: "智慧学院", water_device_name: "勤学楼外分区"},
						{pma_value: "0.078", water_device_code: "970850443", dept_name: "智慧学院", water_device_name: "砺学楼外分区"},
						{pma_value: "0.395", water_device_code: "970850467", dept_name: "智慧学院", water_device_name: "宿舍区泵房"},
						{pma_value: "0.302", water_device_code: "970850448", dept_name: "智慧学院", water_device_name: "战训楼"},
						{pma_value: "0.36", water_device_code: "970850459", dept_name: "智慧学院", water_device_name: "食堂"},
						{pma_value: "0.385", water_device_code: "970850434", dept_name: "智慧学院", water_device_name: "宿舍4栋"},
						{pma_value: "0.096", water_device_code: "970850424", dept_name: "智慧学院", water_device_name: "战训基地"},
						{pma_value: "0.008", water_device_code: "970850457", dept_name: "智慧学院", water_device_name: "宿舍2栋"},
						{pma_value: "0.394", water_device_code: "970850464", dept_name: "智慧学院", water_device_name: "宿舍3栋"},
						{pma_value: "0.433", water_device_code: "970850449", dept_name: "智慧学院", water_device_name: "行政楼泵房"},
						{pma_value: "0.401", water_device_code: "970850460", dept_name: "智慧学院", water_device_name: "宿舍1栋"},
						{pma_value: "0.011", water_device_code: "970850469", dept_name: "智慧学院", water_device_name: "礼堂右侧消防"},
						{pma_value: "0.08", water_device_code: "970850447", dept_name: "智慧学院", water_device_name: "砺学楼"},
						{pma_value: "0.082", water_device_code: "970850437", dept_name: "智慧学院", water_device_name: "实验楼"},
						{pma_value: "0.072", water_device_code: "970850436", dept_name: "智慧学院", water_device_name: "图书馆"}
          ];
          this.$store.state.pressdata=this.pressuredata;
          setTimeout(()=>{
            this.$nextTick(() => { 
            new BScroll(this.$refs.scroll_1, {
                scrollX: false,
                scrollY: true,
                click: true,
                mouseWheel: true,
                scrollbar: {
                  customElements: [this.$refs.vertical_1],
                  fade: true,
                  interactive: true,
                  scrollbarTrackClickable: true
                }      
              }) 
            })
          },300)
//      })
//      .catch((error) => {
//        console.log(error+"网络链接错误！");
//      });
    }
  },
  filters:{
    pressNumFilter(item){
      return Number(item).toFixed(2)
    }
  }
};
</script>

<style scoped>
#pressure {
  margin-top: 1.48vh;
  height: 25.09vh;
  background: url("@/assets/pengshui_bg.png") no-repeat center center;
  color: #ffffff;
  background-size: 100% 100%;
}
.title {
  color: #ffffff;
  text-align: start;
  height: 4.5vh;
  line-height: 4.5vh;
  margin-left: 1.04vw;
  font-size: 18px;
  padding-top: 0.1vh;
}

.tab_1 {
  display: flex;
  justify-content: space-evenly;
  color: #649cff;
  font-size: 12px;
  margin-bottom: 1.111vh;
}
.tab_1 li {
  flex: 1;
}
.box_1 {
  height: 2.96vh;
  line-height: 2.96vh;
  font-size: 12px;
  width: 98%;
  margin-top: 0.46vh;
}
.box_2 {
  width: 100%;
  display: flex;
  /* justify-content: space-around; */
}
.box_2 li {
  flex: 1;
}
.box_2 :nth-child(2){
  flex: 1.2;
}
.change_color {
  background: #1e366b;
}
.alertcolor{
  background: red;
}
.scroll {
  overflow: hidden;
  width: 95%;
  height: 14.9vh;
  cursor: pointer;
  position: relative;
}

/* 滚动条样式 */
/* .scroll::-webkit-scrollbar {
  width: 0.26vw;
  height: 0.925vh;
  border-radius: 3px;
} */
/* 背景样式 */
/* .scroll::-webkit-scrollbar-track {
  background: rgb(238, 236, 236);
  border: 1px solid gray;
} */
/* 背景上面的条条样式 */
/* .scroll::-webkit-scrollbar-thumb {
  background: gray;
  border-radius: 10px;
} */
</style>